<script lang="ts">
	import { onDestroy, SvelteComponent } from "svelte";
	import { storeCurRoute, routes } from "../scripts/router1";
	import { storeIsPodcastDisplayed } from "../scripts/store";

	let component: typeof SvelteComponent;
	export let anchor: string = "";

	const unsubscribe = storeCurRoute.subscribe((routeId) => {
		const route = routes.filter((r) => r.id === routeId)[0];
		component = route.component;
		if (route.anchor != "") {
			anchor = route.anchor;
		} else {
			anchor = "";
		}
	});

	onDestroy(unsubscribe);
</script>

<style lang="scss">
	.route {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		padding: 0 0 25px 0;
		margin: 0 0 200px 0;
		&__podcast {
			padding: 0 0 150px 0;
		}
	}

	@include large {
		.route {
			margin: 0 0 0 0;
			height: 100%;
		}
	}

</style>

<div class="route" class:route__podcast={$storeIsPodcastDisplayed}>
	{#if anchor != ""}
		{#key anchor}
			<svelte:component this={component} {anchor} />
		{/key}
	{:else}
		<svelte:component this={component} />
	{/if}
</div>
